import { CmsEntities } from './cmsConstants';
import { createSelector } from 'reselect';
import { CmsEntityDataTypes, CmsReducerState } from './cmsTypes';

export const getCmsSelector = (state: any): CmsReducerState => state.getIn(['app', 'cms']);
export const getCmsData = <T extends CmsEntities>(cmsType: T) =>
    createSelector(getCmsSelector, (cms): CmsEntityDataTypes[T] => cms[cmsType]?.data);
